// extracted by mini-css-extract-plugin
export default {"mikaQuoteBlock":"MikaQuoteBlock_mikaQuoteBlock__Jg12u","authorContainer":"MikaQuoteBlock_authorContainer__kQwxT","blue":"MikaQuoteBlock_blue__xEtaY"};